//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as ChevronRightSmallSVG } from './assets/small/chevron-right.inline.svg'

interface ChevronRightSmallIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const ChevronRightSmallIcon: React.FC<
  React.PropsWithChildren<ChevronRightSmallIconProps>
> = forwardRef<ChevronRightSmallIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={ChevronRightSmallSVG}
      sx={sx}
      color={color}
    />
  )
)
